export function validatePhone(phone: string) {
  return phone.length <= 11 && phone.length >= 10 && phone.startsWith('010');
}
